import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PaymentTypeMap } from "../../helper";
import { getPaymentTypes } from "../../redux/actions/lookups/getPaymentTypes";

const usePaymentTypes = (setLoading) => {
  const dispatch = useDispatch();
  const { paymentTypes } = useSelector(
    (state) => state.getTransactionMethods
  );
  const [paymentType, setPaymentType] = useState([]);

  useEffect(() => {
    if (!paymentTypes || paymentTypes.length === 0) {
      setLoading(true);
      dispatch(getPaymentTypes())
        .then((methods) => setPaymentType(methods))
        .catch((error) =>
          console.error("Error fetching transaction method:", error)
        );
      setLoading(false);
    } else {
      setPaymentType(paymentTypes);
    }
    // eslint-disable-next-line
  }, [paymentTypes]);

  const getPaymentBylable = (id) => {
    if (paymentType && id) {
      const type = paymentType.find((type) => type.id === id).name;
      return type ? type : "";
    }
    return null;
  };


  const mappedPaymentTypes = paymentType.map((type) => ({
    label: PaymentTypeMap[type.name] || type.name,
    value: type.id,
  }));

  return [mappedPaymentTypes, getPaymentBylable];
};

export default usePaymentTypes;
